import * as React from "react";
import styled from "styled-components";
import { Row, Col } from "antd";

type StyledColProps = {
  additionalMarginTop: number;
};

const StyledCol = styled(Col)`
  max-width: 100%;
  margin-top: ${(props: StyledColProps) => props.additionalMarginTop + 50}px;
  margin-bottom: 50px;
  flex: 0 0 876px;
  background-color: white;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.25);

  @media only screen and (max-width: 876px) {
    flex: 1;
    margin: 0;
  }
`;

type Props = {
  additionalMarginTop?: number;
};

export const MainComponentContainer: React.FC<Props> = props => {
  return (
    <Row justify="center" type="flex">
      <StyledCol
        span="auto"
        additionalMarginTop={props.additionalMarginTop || 0}
      >
        {props.children}
      </StyledCol>
    </Row>
  );
};
